export default "__VITE_ASSET__ab6dbdb0__"